import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { loginLtiSSO, loginService } from "../services/AuthService";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Box, CircularProgress, Typography } from "@mui/material";

const defaultTheme = createTheme();

export default function LtiSSO() {
	const { login } = React.useContext(AuthContext);
	const [keyError, setKeyError] = React.useState(false);
    const [secondsLeft, setSecondsLeft] = React.useState(6);
	const navigate = useNavigate();
    
	const onLogin = async (event) => {
		try {
			const searchParams = new URLSearchParams(window.location.search);
			const key = searchParams.get("key");
			const response = await loginLtiSSO(key);
			login(response, "Academico");

			navigate("/app", {
				replace: true,
			});
		} catch (error) {
			setKeyError(true);
		}
	};

	React.useEffect(() => {
		onLogin();

        if (!keyError) return;
        const interval = setInterval(() => {
            setSecondsLeft((prev) => {
              if (prev <= 1) {
                clearInterval(interval);
                navigate("/",{
                     	replace: true,
                     }); // Ruta destino si el login falla
              }
              return prev - 1;
            });
          }, 1000);
      
          return () => clearInterval(interval);
        }, [keyError, navigate]);

	return (
		<ThemeProvider theme={defaultTheme}>
			<Container
				component="main"
				maxWidth="xl"
				sx={{
					height: "100vh",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<CssBaseline />

				{!keyError ? (
					<>
						<Box sx={{ display: "flex" }}>
							<CircularProgress />
							<br />
						</Box>{" "}
						<Typography>Cargando información, pronto seras redirigido....</Typography>
					</>
				) : (
					<Typography>Ocurrio un error, contactaca a un administrador, Redirigiendo en {secondsLeft}</Typography>
				)}
			</Container>
		</ThemeProvider>
	);
}
